<template>
  <div class="app_cp">
    <div class="homebanner">
      <img src="@/assets/home/banner.png" alt="">
    </div>
    <div class="homerecommend">
      <div class="homerecommendtop">
        <h3>
          产品推荐{{ str1.a }}
          <span class="heng"></span>
        </h3>
      </div>
      <div class="pl" style="margin-right: -100px;padding-left: 14px;">
        <div class="homerecommendTxtmg" v-for="(item, index) in list" :key="index">
          <div class="boximg">
            <img :src="item.img" alt="">
          </div>
          <div class="text">
            <h5>{{ item.title }}</h5>
            <p>
              <span class="chang">厂</span>
              <span class="Pspan">{{ item.manufactor }}</span>
            </p>
          </div>
        </div>
      </div>

    </div>
    <div class="homemy">
      <div class="homerecommendtop">
        <h3>
          关于我们
          <span class="heng"></span>
        </h3>
      </div>
      <div class="homemyText">
        <div class="homemyImg">
          <img src="@/assets/home/home.png" alt="">
        </div>
        <div class="homemytxt" v-for="(item, index) in text" :key="index">
          <p>
            <span class="leftL"></span>
            <span>{{ item.title }}</span>
          </p>
          <p style="font-size:12px">{{ item.text }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>

import { ref, reactive, toRefs, getCurrentInstance } from "vue"
import { useRouter } from 'vue-router'
// const {proxy} = getCurrentInstance()
// proxy.$message({ type: 'error', message: '登录失败' }) 


let str1 = reactive({
  list: [
    {
      id: "xg",
      title: "桂林西瓜霜",
      manufactor: "桂林三金药业股份有限公司",
      img: require("@/assets/home/a2.png")
    },
    {
      id: "cy",
      title: "肠炎宁片",
      manufactor: "江西康恩贝中药有限公司",
      img: require("@/assets/home/a5.png")
    },
    {
      id: "gm",
      title: "感冒灵颗粒",
      manufactor: "华润三九医药股份有限公司",
      img: require("@/assets/home/gm/home.jpg")
    },
    {
      id: "rs",
      title: "乳酸菌素片",
      manufactor: "江中药业股份有限公司",
      img: require("@/assets/home/rs/home.jpg")
    },],
  text: [{
    title: "药房信息",
    text: "武汉健博会大药房有限公司，于2022年09月20号正式成立，主要经营药品、食品、医疗器械及大健康相关产品。"
  },
  {
    title: "产品经营信息",
    text: "武汉健博会大药房主经营品种主要以药品、医疗器械产品为主。"
  }]
})
let { list, text } = toRefs(str1)

const router = useRouter()


function shopDetails (id) {
  router.push({
    path: `details`,
    query: { id }
  })
}

</script>

<style scoped lang="less">
.app_cp {
  background: #ffffff;
}

.homebanner {
  img {
    width: 100%;
  }
}

.homerecommend {
  width: 1024px;
  margin: 0 auto;
  margin-top: -5px;
  padding: 28px 0px;

  .homerecommendtop {
    text-align: center;
    margin-bottom: 25px;

    .heng {
      display: block;
      width: 38px;
      height: 3px;
      background-color: #116d52;
      margin: 3px auto;
    }
  }

  .homerecommendTxtmg {
    width: 156px;
    margin-right: 120px;
    display: inline-block;
    text-align: center;
    margin-top: 20px;

    .boximg {
      width: 119px;
      height: 109px;
      padding: 20px;
      border: 1px solid #d9d9d9;
    }

    img {
      width: 72px;
      height: 87px;
      transition: all 0.3s ease;
    }

    img:hover {
      transform: scale(1.1);
    }

    .text {
      text-align: left;

      h5 {
        margin: 7px 0px;
        width: 156px;
        height: 35px;
        font-size: 12px;
        -webkit-line-clamp: 2;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      p {
        margin: 0px;
        font-size: 12px;
        display: flex;

        .chang {
          width: 18px;
          height: 15px;
          text-align: center;
          background-color: #b4c8ff;
          margin-right: 5px;
        }

        .Pspan {
          width: 156px;

          -webkit-line-clamp: 1;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.homemy {
  width: 1024px;
  margin: 0 auto;
  margin-top: -5px;
  padding: 28px 0px;

  .homerecommendtop {
    text-align: center;
    margin-bottom: 25px;

    .heng {
      display: block;
      width: 38px;
      height: 3px;
      background-color: #116d52;
      margin: 3px auto;
    }
  }

  .homemyText {
    width: 900px;
    margin-left: 50px;

    .homemyImg {
      height: 321px;

      img {
        width: 100%;
      }
    }

    .homemytxt {
      p {
        display: flex;
        margin-bottom: 10px;
      }

      .leftL {
        display: block;
        width: 3px;
        height: 16px;
        background-color: #116d52;
        margin-right: 6px;
        margin-top: 3px;
      }
    }
  }
}
</style>
